import { AxiosRequestConfig } from 'axios'
import { httpClient } from './http-client'

export const baseFetcher = (url: string, config?: AxiosRequestConfig) =>
  httpClient.get(url, config).then(res => res.data)
